import { render, staticRenderFns } from "./_postAttachFilesButton.vue?vue&type=template&id=e08960da"
import script from "./_postAttachFilesButton.vue?vue&type=script&lang=js"
export * from "./_postAttachFilesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports